import React, { Component, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const passwordIcon = require("./../assets/img/password-icon.svg").default;

const ChangePassword = () => {
  const [formData, setFormData] = useState({
    old_password: "",
    new_password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const [loginStatus, setLoginStatus] = useState("");
  const [userId, setUserId] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState("");

  const handleChange = (event) => {
    const { name, value, type, checked } = event.target;
    const newValue = type === "checkbox" ? checked : value;

    if (name === "confirm_password") {
      setConfirmPassword(newValue);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
    }
  };

  const isStrongPassword = (password) => {
    const minLength = 8;
    const hasUppercase = /[A-Z]/.test(password);
    const hasLowercase = /[a-z]/.test(password);
    const hasNumber = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(
      password
    );

    return (
      password.length >= minLength &&
      hasUppercase &&
      hasLowercase &&
      hasNumber &&
      hasSpecialChar
    );
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prevShowPassword) => !prevShowPassword);
  };
  const togglePasswordVisibility2 = () => {
    setShowPassword2((prevShowPassword2) => !prevShowPassword2);
  };
  const togglePasswordVisibility3 = () => {
    setShowPassword3((prevShowPassword3) => !prevShowPassword3);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (formData.new_password !== confirmPassword) {
      setLoginStatus("New password and confirm password don't match");
      return;
    }

    if (!isStrongPassword(formData.new_password)) {
      setLoginStatus("Password is not strong enough");
      return;
    }

    const form = new FormData();
    form.append("user_id", userData ? userData.id : "");
    form.append("old_password", formData.old_password);
    form.append("new_password", formData.new_password);

    try {
      const response = await fetch(
        "https://cliqestimatebuilder.com/waiver_admin/change-password",
        {
          method: "POST",
          body: form,
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        }
      );
      const responseData = await response.json();
      if (responseData.res === "1") {
        // Password change successful, you can handle accordingly
        setLoginStatus(responseData.msg);
      } else {
        // Password change failed, display an error message
        setLoginStatus(responseData.msg);
      }
    } catch (error) {
      console.error("Error during password change:", error);
    }
  };

  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);
    if (storedUserData) {
      setUserId(storedUserData.userId); // Replace 'userId' with the actual key in your user data object
    }
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewBox passwordDiv">
            <h2>Change password</h2>

            <form onSubmit={handleSubmit}>
              <ul>
                <li>
                  <label>Old Password:</label>
                  <input
                    type={showPassword ? "text" : "password"}
                    name="old_password"
                    value={formData.old_password}
                    onChange={handleChange}
                    placeholder="Type your old password"
                  />
                  <div
                    className="visibleClick"
                    onClick={togglePasswordVisibility}
                  >
                    <img src={passwordIcon} alt="Toggle Password Visibility" />
                  </div>
                </li>
                <li>
                  <label>New Password:</label>
                  <input
                    type={showPassword2 ? "text" : "password"}
                    name="new_password"
                    value={formData.new_password}
                    onChange={handleChange}
                    placeholder="Type your new password"
                  />
                  <div
                    className="visibleClick"
                    onClick={togglePasswordVisibility2}
                  >
                    <img src={passwordIcon} alt="Toggle Password Visibility" />
                  </div>
                  <div className="passwordStrengthMessage">
                    {isStrongPassword(formData.new_password)
                      ? "Password is strong"
                      : "Password must be at least 8 characters long and include uppercase, lowercase, number, and special character"}
                  </div>
                </li>
                <li>
                  <label>Confirm Password:</label>
                  <input
                    type={showPassword3 ? "text" : "password"}
                    name="confirm_password"
                    value={confirmPassword}
                    onChange={handleChange}
                    placeholder="Confirm your new password"
                  />
                  <div
                    className="visibleClick"
                    onClick={togglePasswordVisibility3}
                  >
                    <img src={passwordIcon} alt="Toggle Password Visibility" />
                  </div>
                </li>

                <li>
                  <button type="submit">Save</button>
                </li>
                <span className="lgnStatus algnLft">{loginStatus}</span>
              </ul>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
